import { createContext } from "react";
const articleContext = createContext();

export default articleContext;
